/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { FEATURES_DEFAULTS } from '../constants/EarlyRequesterNames';
import { getI18nLangLocale } from '../utils/languageUtils';
import { getIsQAProxy } from '../utils/proxyUtils';
import getEarlyRequesterResult from './getEarlyRequesterResult';
export const getFeatures = ({
  highlightedProducts
}) => {
  const i18nLangLocale = getI18nLangLocale();
  return noAuthHttp.get(`${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/feature/store/v1/features/by-api-names/translated`, {
    query: {
      productApiNames: highlightedProducts,
      i18nLangLocale
    }
  });
};
export const getFeaturesWithDefaults = () => {
  const i18nLangLocale = getI18nLangLocale();
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/feature/store/v1/features/defaults/${i18nLangLocale}`;
  const earlyRequest = getEarlyRequesterResult(FEATURES_DEFAULTS);
  const getFeaturesWithDefaultsPromise = () => noAuthHttp.get(url);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => getFeaturesWithDefaultsPromise()) : null;
  return earlyRequestWithRetry || getFeaturesWithDefaultsPromise();
};